import React from 'react';
import styled from 'styled-components';
import davidoff from '../../../../../themes/davidoff';

export default styled.div`
  &.opened {
    border-bottom: 1px solid ${davidoff.colors.gray};
  }
`;
